import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

function formatDateTime(dt: string | null): string {
  if (!dt) return '—';
  return new Date(dt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function AdminZuschlaegePage() {
  const [cases, setCases] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadCases(); }, []);

  async function loadCases() {
    const { data, error } = await supabase
      .from('compliance_cases')
      .select('*, auctions(aktenzeichen, titel, status), profiles!inner(companies(name, ansprechpartner_vorname, ansprechpartner_nachname))')
      .order('frist_ablauf', { ascending: true });
    if (data) setCases(data);
    setLoading(false);
  }

  async function updateCompliance(caseId: string, field: string, value: boolean) {
    await supabase.from('compliance_cases').update({ [field]: value }).eq('id', caseId);
    if (field === 'zahlungseingang_bestaetigt' && value) {
      await supabase.from('compliance_cases').update({ zahlungseingang_at: new Date().toISOString() }).eq('id', caseId);
    }
    loadCases();
  }

  async function setAdminNotes(caseId: string, notes: string) {
    await supabase.from('compliance_cases').update({ notizen_admin: notes }).eq('id', caseId);
    loadCases();
  }

  if (loading) return <div className="container-content py-12"><p className="text-text-secondary">Laden...</p></div>;

  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Zuschläge und Compliance</h1>

      {cases.length === 0 ? (
        <p className="text-text-secondary text-sm">Keine Compliance-Cases vorhanden.</p>
      ) : (
        <div className="space-y-4">
          {cases.map((cc) => (
            <div key={cc.id} className="p-4 border border-surface-border rounded-sm">
              <div className="flex items-center justify-between mb-3">
                <h2 className="text-sm font-serif">
                  {cc.auctions?.aktenzeichen} — Rang {cc.rang}
                </h2>
                <span className="font-mono text-xs">{cc.gesamt_status}</span>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm mb-3">
                <p><strong>Bieter:</strong> {cc.profiles?.companies?.ansprechpartner_vorname} {cc.profiles?.companies?.ansprechpartner_nachname}</p>
                <p><strong>Unternehmen:</strong> {cc.profiles?.companies?.name}</p>
                <p><strong>Frist:</strong> {formatDateTime(cc.frist_ablauf)}</p>
              </div>

              <div className="space-y-2 mb-3">
                <label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={cc.kyc_dokumente_eingegangen}
                    onChange={(e) => updateCompliance(cc.id, 'kyc_dokumente_eingegangen', e.target.checked)} />
                  KYC-Dokumente eingegangen
                </label>
                <label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={cc.sanktionslistenpruefung_bestanden}
                    onChange={(e) => updateCompliance(cc.id, 'sanktionslistenpruefung_bestanden', e.target.checked)} />
                  Sanktionslistenprüfung bestanden
                </label>
                <label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={cc.zahlungseingang_bestaetigt}
                    onChange={(e) => updateCompliance(cc.id, 'zahlungseingang_bestaetigt', e.target.checked)} />
                  Zahlungseingang bestätigt
                </label>
              </div>

              <div>
                <label className="block text-sm text-text-muted mb-1">Admin-Notizen</label>
                <textarea
                  className="input-field text-sm"
                  rows={2}
                  value={cc.notizen_admin || ''}
                  onChange={(e) => setAdminNotes(cc.id, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
